import { Button, Text } from 'components';
import { cn } from 'utils';
import GetStartedButton from './GetStartedButton';
import { getStartedMetaDataList } from './utils';
import satelliteImg from 'assets/satellite.png';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const GetStarted = () => {
  const { t } = useTranslation();

  const onMoveArcade = () => {
    window.open('https://app.arcade.software/share/Zfz276zBBPERwE54aqOh', '_blank');
  };

  return (
    <>
      <Helmet>
        <title>{t('getStarted.pageTitle')} | IOPS SPACE</title>
        <meta name="description" content={t('getStarted.pageDescription')} />
      </Helmet>
      <div className="flex h-full w-full flex-col gap-2 p-4">
        <div className={cn('flex h-[506px] flex-col items-center justify-center gap-6', 'md:flex-1')}>
          <img src={satelliteImg} alt="satellite-img" className="h-200 object-contain" />
          <div className={cn('w-full', 'md:w-[800px]')}>
            <h2 className="mb-3 text-center align-middle text-heading1 font-medium text-text-primary">
              {t('getStarted.pageTitle')}
            </h2>
            <Text className="text-center" weight="regular" size="body2" color="secondary">
              {t('getStarted.pageDescription')}
            </Text>
          </div>
          <div className="flex flex-col items-center">
            <Button
              text={t('getStarted.button.tutorial')}
              size="large"
              onClick={onMoveArcade}
              aria-label="Go to arcade tutorial page"
            />
          </div>
        </div>

        <div className={cn('grid grid-cols-1 grid-rows-2 gap-2', 'md:h-1/2 md:grid-cols-3 md:grid-rows-1')}>
          {getStartedMetaDataList.map((metadata) => (
            <GetStartedButton
              key={metadata.title}
              icon={metadata.icon}
              path={metadata.path}
              hoverStyle={metadata.hoverStyle}
              subtitleColor={metadata.subtitleColor}
              className={metadata.hoverStyle}
              title={t(metadata.title)}
              subtitle={t(metadata.subtitle)}
              description={t(metadata.description)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default GetStarted;
